import defaultColor from "@/components/color";

const dataJson = [
    { "devName": "节点1", "ip": "127.0.0.1", "level": "/imgPool/20220311094135huifu.png", "belong": "派出所1" },
    { "devName": "节点2", "ip": "192.0.10.1", "level": "/imgPool/20220310182434gaojing.png", "belong": "派出所2" },
    { "devName": "节点3", "ip": "127.0.0.1", "level": "/imgPool/20220310182414guzhang.png", "belong": "派出所3" },
    { "devName": "节点4", "ip": "192.168.0.1", "level": "/imgPool/20220310182414guzhang.png", "belong": "派出所4" }
]

export default {
    cptDataForm: {
        dataSource: 1, pollTime: 0, dataText: JSON.stringify(dataJson),
    },
    // interaction:{intType: 'none'},
    interaction: {
        // tableActive:'', // 列或行点击
        // columnclickValue:"",
        // intType:"display",
    },
    attribute: {
        // theadBg:[defaultColor[0],defaultColor[1]],
        theadBg: ['#081449', '#081449'],
        theadHeight: 68, theadColor: '#6aa9e4', theadSize: 14, tbodyColor: '#fff', tbodySize: 13,
        // oddRowBg:defaultColor[0],//奇数行背景色
        // evenRowBg:defaultColor[1],//偶数行背景色
        oddRowBg: 'rgba(0,71,143,0.41)',
        evenRowBg: 'rgba(18,123,251,0.38)',
        rowHeight: 0,
        showLine: 5, showIndex: true,
        current: 1,
        borderColor: '#aaa',
        chooseColor: '#fff',
        chooseRowBg: 'rgba(0,71,143,0.41)',
        lineHeight: 30,
        borderType: '',//all,button,none
        showTableHeader: true,
        defaultRowIndex: 0,
        fontWeight: 'normal',
        columns: [
            { colKey: 'devName', title: '设备名称', type: 'text', width: 0, enableGradual: 1, id: 't02' },
            { colKey: 'ip', title: 'ip地址', type: 'text', width: 0, enableGradual: 1, id: 't03' },
            { colKey: 'level', title: '预警级别', type: 'img', width: 0, enableGradual: 1, id: 't04' },
            { colKey: 'belong', title: '设备所属', type: 'text', width: 0, enableGradual: 1, id: 't05' }
        ]
    }
}
